// extracted by mini-css-extract-plugin
export var address = "LocationCard-module--address--8dd68";
export var body = "LocationCard-module--body--a0c9a";
export var container = "LocationCard-module--container--dde03";
export var distance = "LocationCard-module--distance--773ab";
export var image = "LocationCard-module--image--b1c61";
export var isCard = "LocationCard-module--isCard--adf10";
export var isPrimary = "LocationCard-module--isPrimary--5edc1";
export var tel = "LocationCard-module--tel--d4cc6";
export var title = "LocationCard-module--title--ae264";